<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "DocumentIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
